import { app } from '../../../../../app';
import { Controller } from './groups-apps.controller';

app.component('companyUserDirectoriesManageAccountGroupsApps', {
    bindings: {
        accountId: '<',
        companyId: '<',
        groupsAndApps: '<',
    },
    controller: Controller,
    templateUrl: require('./groups-apps.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-account/groups-apps/groups-apps.component.js